import React from 'react'

import { SiteContext } from 'context/site-context'

import cn from 'classnames'

import Logo from 'components/atoms/Logo'
import SearchForm from 'components/atoms/SearchForm'
import { isWebpSupported } from 'helpers'

import './index.scss'

const Header = props => {
  const [ site ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    expanded: false,
  })

  return (
    <header className={cn( props.className, { visible: props.showHeader, animate: props.animate })}>
      <div className="container">
        <div className="wrapper">
          <div className="main-logo-container"><Logo /></div>
          <div className={cn('actions-container', { expanded: state.expanded }) }>
            <div className="form-wrapper">
              <span className="close-trigger" onClick={ () => setState({ expanded: false })}><img src="//s3.amazonaws.com/assets.elocal.com/sem/assets/images/icons/close-white.svg" alt="close" /></span>
              <SearchForm className="mini" />
            </div>
            <div className="social-container">
              <span onClick={ () => setState({ expanded: true })}><img src="//s3.amazonaws.com/assets.elocal.com/sem/assets/images/icons/magnifying-glass-white.svg" /></span>
              {site.social?.map( item => <a href={item.url} key={item.label}><img src={item.img} alt={item.label}/></a>)}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
